module.exports = __webpack_public_path__ + "static/media/aussie-moment.88bdae57.svg";